/** @jsx jsx */
import { jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { alignCenter, alignLeft, alignRight } from '@atlaskit/editor-common/keymaps';
import { alignmentMessages } from '@atlaskit/editor-common/messages';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { IconMap } from '../ToolbarAlignment/icon-map';
import AlignmentButton from './AlignmentButton';
import { alignmentWrapper } from './styles';
var alignCenterKeyboardShortcut;
var alignRightKeyboardShortcut;
if (getBooleanFF('platform.editor.text-alignment-keyboard-shortcuts')) {
  alignCenterKeyboardShortcut = alignCenter;
  alignRightKeyboardShortcut = alignRight;
}
var alignmentOptions = [{
  title: alignmentMessages.alignLeft,
  shortcut: alignLeft,
  value: 'start'
}, {
  title: alignmentMessages.alignCenter,
  shortcut: alignCenterKeyboardShortcut,
  value: 'center'
}, {
  title: alignmentMessages.alignRight,
  shortcut: alignRightKeyboardShortcut,
  value: 'end'
}];
function Alignment(_ref) {
  var onClick = _ref.onClick,
    selectedAlignment = _ref.selectedAlignment,
    className = _ref.className,
    intl = _ref.intl;
  return jsx("div", {
    "data-testid": "alignment-buttons"
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    ,
    css: alignmentWrapper,
    className: className
  }, alignmentOptions.map(function (alignment) {
    var value = alignment.value,
      title = alignment.title,
      shortcut = alignment.shortcut;
    var message = intl.formatMessage(title);
    return jsx(AlignmentButton, {
      content: jsx(IconMap, {
        alignment: value
      }),
      key: value,
      value: value,
      label: message,
      shortcut: shortcut,
      onClick: onClick,
      isSelected: value === selectedAlignment
    });
  }));
}
export default injectIntl(Alignment);